import { hasAuthCookies, clearAuthCookies } from "@/utils/cookieUtils";

class AuthService {
  constructor() {
    this.sessionCheckInterval = null;
    this.isCheckingSession = false;
    this.store = null;
    this.visibilityHandler = this.handleVisibilityChange.bind(this);
    this.focusHandler = this.handleWindowFocus.bind(this);
  }

  startAuthChecking(store) {
    this.store = store;
    this.checkSessionStatus();

    this.sessionCheckInterval = setInterval(() => {
      this.checkSessionStatus();
    }, 2 * 60 * 1000); // Check every 2 minutes

    document.addEventListener("visibilitychange", this.visibilityHandler);
    window.addEventListener("focus", this.focusHandler);
  }

  stopAuthChecking() {
    if (this.sessionCheckInterval) {
      clearInterval(this.sessionCheckInterval);
      this.sessionCheckInterval = null;
    }

    document.removeEventListener(
      "visibilitychange",
      this.visibilityHandler
    );
    window.removeEventListener("focus", this.focusHandler);
  }

  checkSessionStatus() {
    if (!this.store || this.isCheckingSession) return;

    this.isCheckingSession = true;

    try {
      // Check if cookies exist
      if (!hasAuthCookies()) {
        this.logoutUser();
        return;
      }

      // Check if user is already logged out in store
      if (this.store.getters["auth/loggedIn"] === false) {
        return;
      }

      // Check JWT token expiration
      const token = localStorage.getItem("webToken");
      if (!token || this.isTokenExpired(token)) {
        this.logoutUser();
        return;
      }

      // Check if user data exists in localStorage
      const user = localStorage.getItem("webUser");
      if (!user) {
        this.logoutUser();
        return;
      }

      // Session is valid, ensure store is updated
      if (!this.store.getters["auth/loggedIn"]) {
        this.store.commit("auth/SET_LOGGED_IN", true);
        this.store.commit("auth/SET_USER", JSON.parse(user));
      }
    } catch (error) {
      console.error("Error checking session status:", error);
      this.logoutUser();
    } finally {
      this.isCheckingSession = false;
    }
  }

  handleWindowFocus() {
    this.checkSessionStatus();
  }

  handleVisibilityChange() {
    if (!document.hidden) {
      this.checkSessionStatus();
    }
  }

  isTokenExpired(token) {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return (
              "%" +
              ("00" + c.charCodeAt(0).toString(16)).slice(-2)
            );
          })
          .join("")
      );

      const decodedToken = JSON.parse(jsonPayload);
      if (!decodedToken || !decodedToken.exp) {
        return true;
      }

      const currentTime = Math.floor(Date.now() / 1000);
      return decodedToken.exp < currentTime;
    } catch (error) {
      return true; // If token is invalid, treat as expired
    }
  }

  logoutUser() {
    this.store.commit("auth/SET_LOGGED_IN", false);
    this.store.commit("auth/SET_USER", null);
    clearAuthCookies();
    localStorage.removeItem("webToken");
    localStorage.removeItem("webUser");
    localStorage.removeItem("uuid");
  }
}

export default new AuthService();
